import { CfEntrySource, CfSubCase } from './api/CfProbeResponse';
import type { CfFlowResponse } from './api/cloudflareFlowApi';

export const CF_FLOW_VERSION = 'beta';

export const UNKNOWN_SUB_CASE = 'unknown';

/** Matches the `sub_case` rest-api stamps on the Probe Result of a blocked domain. */
export const BLOCKED_SUB_CASE = 'blocked';

export const DEFAULT_ENTRY_SOURCE: CfEntrySource = 'wizard';

export type CfEventSubject = {
  readonly domain: string;
  readonly subCase?: CfSubCase | typeof BLOCKED_SUB_CASE | null;
  readonly entrySource?: CfEntrySource;
};

export const cfEventSubjectOf = ({ domain, status, subCase, entrySource }: CfFlowResponse): CfEventSubject => ({
  domain,
  subCase: status === 'blocked' ? BLOCKED_SUB_CASE : subCase,
  entrySource,
});

export type CfSharedEventProperties = {
  sub_case: string;
  flow_version: string;
  entry_source: CfEntrySource;
  company_id: number | undefined;
  domain: string;
};

/** Mirrors rest-api's `cfEventProperties`; the two must stamp the same properties. */
export const cfEventProperties = (
  subject: CfEventSubject | undefined,
  companyId: number | undefined,
): CfSharedEventProperties => ({
  sub_case: subject?.subCase ?? UNKNOWN_SUB_CASE,
  flow_version: CF_FLOW_VERSION,
  entry_source: subject?.entrySource ?? DEFAULT_ENTRY_SOURCE,
  company_id: companyId,
  domain: subject?.domain ?? '',
});
